import { render, staticRenderFns } from "./seckillAct.vue?vue&type=template&id=ae0b50ce&scoped=true&"
import script from "./seckillAct.vue?vue&type=script&lang=js&"
export * from "./seckillAct.vue?vue&type=script&lang=js&"
import style0 from "./seckillAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./seckillAct.vue?vue&type=style&index=1&id=ae0b50ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0b50ce",
  null
  
)

component.options.__file = "seckillAct.vue"
export default component.exports